import { FloorplanListData } from 'src/components/agile/zoneViewer/zoneMapDataType';
import { GetFloorplanInput, useGetFloorplanQuery } from 'src/graphql/generated/graphql';

const useGetFloorplan = (input: GetFloorplanInput) => {
  const { data, isSuccess, isLoading } = useGetFloorplanQuery(
    {
      input,
    },
    {
      // disable refetchOnWindowFocus so that data is not refreshed
      // when user leave the page and come back
      refetchOnWindowFocus: false,
    },
  );

  const floorplanList: FloorplanListData[] = data?.getFloorplan.floorplans ?? [];

  return {
    floorplanList,
    isSuccess,
    isLoading,
  };
};

export default useGetFloorplan;
